'use client';

import { useEffect } from 'react';

import { createMediaFilter } from '@/actions/media';

type UseCreateMediaFilterParams = {
  imageUrl: string | undefined;
  mediaId: number | undefined;
  filterName: string;
};

// Media filters already requested since the last full page load (client-side navigation
// keeps this set). Carousel clones (react-slick `infinite`) and remounts render the same
// trigger several times; one request is enough, and a failed one is not retried.
const requested = new Set<string>();

export function useCreateMediaFilter({
  imageUrl,
  mediaId,
  filterName,
}: UseCreateMediaFilterParams) {
  useEffect(() => {
    if (imageUrl !== undefined || mediaId === undefined) {
      return;
    }

    const key = `${mediaId}:${filterName}`;
    if (requested.has(key)) {
      return;
    }
    requested.add(key);

    void createMediaFilter(mediaId, filterName);
  }, [imageUrl, mediaId, filterName]);
}
